import { Link } from '@qonsoll/react-design'
import PropTypes from 'prop-types'
import { useWebTippsConfigurationBaseActions } from 'domains/WebTippsConfiguration/hooks'

const WebTippsConfigurationDomainNameLink = ({
  text,
  webTippsConfigurationId
}) => {
  const { onOpen } = useWebTippsConfigurationBaseActions({
    webTippsConfigurationId
  })

  const computedText = text || 'N/A'

  return <Link onClick={onOpen}>{computedText}</Link>
}

WebTippsConfigurationDomainNameLink.propTypes = {
  text: PropTypes.string,
  webTippsConfigurationId: PropTypes.string
}

export default WebTippsConfigurationDomainNameLink
